import { render, staticRenderFns } from "./CreatorRequestDisputeIndex.vue?vue&type=template&id=cd227b88&"
import script from "./CreatorRequestDisputeIndex.vue?vue&type=script&lang=js&"
export * from "./CreatorRequestDisputeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports